import { RootState } from '@/store/main';

export const selectSeriesList = (state: RootState) => state.series.seriesList;
export const selectCurrentSeries = (state: RootState) => state.series.currentSeries;
export const selectIsLoadingSeriesList = (state: RootState) => state.series.loadingSeriesList;
export const selectIsLoadingCurrentSeries = (state: RootState) => state.series.loadingCurrentSeries;
export const selectSeriesError = (state: RootState) => state.series.seriesError;
export const selectTopDrawerOpen = (state: RootState) => state.series.topDrawerOpen;
export const selectTotalSeries = (state: RootState) => state.series.totalSeries;
export const selectSeriesUnvailable = (state: RootState) => {
  return (
    state.series.seriesListInitialLoaded && // load is completed
    !state.series.seriesList?.some((series) => series.events && series.events.length) // and no series has any events
  );
};
